import { Controller } from "stimulus";
export default class extends Controller {
  static targets = ["form", "hint"]

  showForm(e) {
    if (e.target.options[e.target.selectedIndex].dataset.showHint === "true") {
      this.formTarget.classList.add("tw-hidden");
      this.hintTarget.classList.remove("tw-hidden");
    } else {
      this.hintTarget.classList.add("tw-hidden");
      this.formTarget.classList.remove("tw-hidden");
    }
  }
}
